<template>
  <div class="tfa-status">
    <el-switch
        v-model="isOn"
        size="small"
        active-text="ON"
        inactive-text="OFF"
        disabled />
    <span
        v-if="showPhone"
        class="tfa-phone disable-html-component">
      <el-tag
          size="mini"
          type="info">
        <span style="font-size: smaller">2SV Phone</span>
      </el-tag>
      <small> {{ phone }}</small>
    </span>
  </div>
</template>

<script>
export default {
  name: "TSVStatus",
  props: {
    isOn: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: String,
      default: "no phone",
    },
  },
  computed: {
    showPhone() {
      return this.isOn && this.phone !== "no phone";
    },
  },
};
</script>

<style>
.tfa-status .el-switch__label > span {
  font-size: 14px;
}
.tfa-phone {
  display: block;
  margin: 7px 0;
}
</style>
